module.exports = __webpack_public_path__ + "static/services-wood-7a3d955e35b5efce8772b9b2a7ad4c83.jpg";